import { DatePipe } from '@angular/common';
import { Field } from '@k2/common/k2-forms-state/types';

export function dateFormatter(datePipe: DatePipe, field: Field): string {
  return datePipe.transform(field.control.value, 'shortDate', '+0000');
}
